import React from 'react';
import Alert from '@cloudscape-design/components/alert';
import Box from '@cloudscape-design/components/box';
import Button from '@cloudscape-design/components/button';
import Modal from '@cloudscape-design/components/modal';
import SpaceBetween from '@cloudscape-design/components/space-between';

interface PolicyModalProps {
  visible: boolean;
  header: string;
  /** Label of the confirm button, e.g. "Create" or "Delete". */
  confirmText: string;
  busy: boolean;
  confirmDisabled?: boolean;
  /** Shown in a red alert; the modal stays open so the user can fix and retry. */
  error: string | null;
  errorHeader: string;
  onCancel: () => void;
  onConfirm: () => void;
  children: React.ReactNode;
}

/** Modal with Cancel / confirm buttons and an inline error, shared by the policy pages' create and delete flows. */
export const PolicyModal: React.FC<PolicyModalProps> = ({
  visible,
  header,
  confirmText,
  busy,
  confirmDisabled,
  error,
  errorHeader,
  onCancel,
  onConfirm,
  children,
}) => (
  <Modal
    visible={visible}
    onDismiss={() => !busy && onCancel()}
    header={header}
    footer={
      <Box float="right">
        <SpaceBetween direction="horizontal" size="xs">
          <Button variant="link" onClick={onCancel} disabled={busy}>
            Cancel
          </Button>
          <Button variant="primary" onClick={onConfirm} loading={busy} disabled={confirmDisabled}>
            {confirmText}
          </Button>
        </SpaceBetween>
      </Box>
    }
  >
    <SpaceBetween size="m">
      {children}
      {error && (
        <Alert type="error" header={errorHeader}>
          {error}
        </Alert>
      )}
    </SpaceBetween>
  </Modal>
);
